module.exports = __webpack_public_path__ + "static/assets/bytesize_microphone.svg";